import api from './api';

// Service pour les statistiques d'achat
export const purchaseStatsService = {
  // Récupérer toutes les statistiques d'achat
  getStats: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.supplierId) params.append('supplierId', filters.supplierId);
    return api.get(`/api/admin/purchase-stats?${params.toString()}`);
  },

  // Récupérer les statistiques d'un fournisseur spécifique
  getSupplierStats: (supplierId, filters = {}) => {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    return api.get(`/api/admin/purchase-stats/supplier/${supplierId}?${params.toString()}`);
  },
};

export default purchaseStatsService;
